"use strict";
const GIF = require("./gif");
module.exports = GIF;
//# sourceMappingURL=index.js.map